<template>
    <div class="toggle toggle-primary" data-plugin-toggle="" data-plugin-options="{ 'isAccordion': true }" ref="mainAccordion">
        <section class="toggle active" data-step="1">
            <label>
                <i class="fas fa-check-circle" v-if="hasSelectedDates"></i>
                <b>STEP 1:</b> Select the travel dates
                <div class="pull-right" style="padding-right: 5px" v-if="hasSelectedDates">
                     {{ computeStepOneTitle }}
                </div>
            </label>
            <div class="toggle-content" style="display: none;">
                <p>Die untenstehende Belegungsliste zeigt</p>
                <ul>
                    <li>Rot: besetzte Tage</li>
                    <li>Grün: freie Tage</li>
                    <li>Tage mit Koffersymbol: Wechseltage. An diesen Tagen muss das Objekt im Verlaufe
                        des Morgens verlassen werden. </li>
                </ul>
                <p>Bitte wählen Sie zuerst das Anreisedatum aus dem Kalender (Schritt 1) und danach in
                    der entsprechenden Liste die gewünschte Aufenthaltsdauer (Schritt 2). Der mit
                    Koffersymbol bezeichnete Tag kann Ihr Abreisetag sein.</p>

                <div id="availabilityContainer">
                    <!-- <CoreDatePicker 
                        v-model="query.selectedDates"
                        :bookings="listing.bookings"
                        :columns="$screens({ default: 1, lg: 4 })"
                        :rows="$screens({ default: 1, lg: 1})" 
                        is-inline>
                    </CoreDatePicker> -->
                </div>
                <div class="pull-right" style="padding: 10px;">
                    <button class="btn btn-primary" @click="gotoStep('2')" :disabled="!hasSelectedDates">Next</button>
                </div>
            </div>
        </section>
        <section class="toggle" data-step="2">
            <label>
                <i class="fas fa-check-circle" v-if="hasSelectedOccupants"></i>
                <b>STEP 2:</b> Verify occupation
                <div class="pull-right" style="padding-right: 5px" v-if="hasSelectedOccupants">
                     {{ computeStepTwoTitle }}
                </div>
            </label>
            <div class="toggle-content">
                <form>
                    <div class="form-row">

                        <div class="col-12 col-md-6">
                            <Stepper v-model="query.numberOfAdults" title="Number of adults" :minValue="1" />
                        </div>

                        <div class="col-12 col-md-6">
                            <Stepper v-model="query.numberOfKids" title="Number of kids" :minValue="0" />
                        </div>
                    </div>
                </form>
                <div class="pull-right" style="padding: 10px;">
                    <button class="btn btn-primary" @click="gotoStep('3')">Next</button>
                    
                </div>
            </div>
        </section>
        <section class="toggle" data-step="3" ref="offerToggle">
            <label @click="triggerPriceUpdate"><b>STEP 3:</b> Select your offer</label>
            <div class="toggle-content">
                <div class="row">
                    <!-- Spinner -->
                    <template v-if="isLoading">
                        <div class="col">
                            <div class="d-flex justify-content-center">
                                <Spinner message="We are looking for compatible offers...please wait"></Spinner>
                            </div>
                        </div>
                    </template>


                    <template v-else>
                        <!-- No results found -->
                        <div class="col-12" id="results" v-if="!isUndefined(results) && results.length === 0">
                            <div class="alert alert-warning">
                                No offers were found for the selected parameters. Try contacting the owner directly?
                            </div>
                        </div>
                        
                        
                        <!-- Error occured -->
                        <!-- No results found -->
                        <div class="col-12" v-if="isUndefined(results)">
                            <div class="alert alert-danger">
                                We apologize, but an error has occured. Please try again later
                            </div>
                        </div>

                        <!-- Price result -->
                        <div class="col-12" v-if="!isUndefined(results) && results.length !== 0">
                            <PriceResult :result="results">
                                <div class="col-12 col-sm-3">
                                    <div class="d-flex justify-content-center align-items-center" style="height: 100%">
                                        <div class="call-to-action-btn btn btn-lg btn-primary" @click="initiateBooking(results)">Contact owner</div>
                                    </div>
                                </div>
                            </PriceResult>
                        </div>    

                    </template>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
    import AlertBox from "@/components/common/AlertBox"
    import Stepper from "@/components/common/Stepper";
    import Spinner from "@/components/common/Spinner";
    import PriceResult from "@/components/level3/PriceResult";
    import CoreDatePicker from "@/components/common/datepicker/CoreDatePicker";

    import {
        mapState
    } from 'vuex';


    export default {
        name: "BookingWidget",
        components: {
            AlertBox,
            Stepper,
            Spinner,
            PriceResult,
            CoreDatePicker
        },
        props: {
            listing: {
                type: Object,
                required: true
            }
        },
        computed: {
            listingId: function() {
                return this.listing.id;
            },
            hasSelectedDates: function() {
                return !this.isUndefined(this.query.selectedDates) && !this.allFieldsAreUndefined(this.query.selectedDates);
            },
            computeStepOneTitle: function() {
                return this.$moment(this.query.selectedDates.start).format("DD.MM.YYYY") + " - " + this.$moment(this.query.selectedDates.end).format("DD.MM.YYYY")
            },

            hasSelectedOccupants: function() {
                return !this.isUndefined(this.query.numberOfAdults) &&
                    !this.isUndefined(this.query.numberOfKids);
            },

            computeStepTwoTitle: function() {
                return [
                    this.computeText(this.query.numberOfAdults, "Adult", "Adults"),
                    this.computeText(this.query.numberOfKids, "Kid", "Kids")
                ].filter(val => val !== "").join(", ");
            },
            ...mapState(['query'])
        },
        methods: {
            submit: function () {
                // TODO: Fire the request, and get all the possible prices
                this.isLoading = !this.isLoading;
                this.errorOccurred = false;

                const payload = {
                    startDate: this.query.selectedDates.start,
                    endDate: this.query.selectedDates.end,
                    numberOfAdults: this.query.numberOfAdults,
                    numberOfKids: this.query.numberOfKids,
                };

                this.$http.post(`offers/${this.listingId}`, payload).then(res => {
                    this.results = res.data;
                    console.log(res.data)
                }).catch(err => {
                    console.log("Cannot retrieve offers")
                    console.log(err.response.data);
                    this.results = [];
                    this.errorOccurred = true;
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            gotoStep: function(stepValue) {
                let steps = Array.from(this.$el.children); // We need to cast this
                let step = steps.filter(el => el.getAttribute("data-step") == stepValue)[0];

                if (!this.isUndefined(step)) {
                    // Access the 'label' html element
                    step.children[0].click();
                }
            },
            computeText: function(value, singularStr, pluralStr) {
                if (value == 0) {
                    return "";
                }

                return value + " " + (value > 1 ? pluralStr : singularStr);
            },
            triggerPriceUpdate: function() {
                this.submit();
            },
            initiateBooking: function(offer) {
                // Commit the current offer, and the listing
                this.$store.commit('setOffer', offer);
                this.$router.push(`/${this.listing.objectId}/booking`)
            }
        },
        data() {
            return {
                isLoading: false,
                results: [],
                errorOccurred: false
            }
        }
    }
</script>

<style lang="scss" scoped>

    .card {
        margin-top: 0px;
    }

    .card-header {
        color: white;
        background-color: $primary-color !important;
        border-color: transparent;
    }

    .card-title > * {
        color: white !important;
        padding: 0;
        margin: 0;
    }
</style>